import { apiSimple } from "../../api";

const AGENDA_ALERTS_PATH = "/api/v3/amei.cloud/agenda-alerts";
const VALID_ALERT_TYPES = ["info", "warning", "critical"];

const getAgendaAlertsUrl = (path = "") => {
  try {
    const baseUrl = new URL(apiSimple.defaults.baseURL);
    return `${baseUrl.origin}${AGENDA_ALERTS_PATH}${path}`;
  } catch {
    return `${AGENDA_ALERTS_PATH}${path}`;
  }
};

const normalizeAlert = (alert) => ({
  id: alert?.id || "",
  key: alert?.key || "",
  title: alert?.title || "Aviso importante",
  content: alert?.content || "",
  type: VALID_ALERT_TYPES.includes(alert?.type) ? alert.type : "info",
  displayMode: alert?.displayMode || "once",
  visibleFrom: alert?.visibleFrom || null,
  visibleUntil: alert?.visibleUntil || null,
  stores: Array.isArray(alert?.stores) ? alert.stores : [],
  department: alert?.department || "all",
  source: alert?.source || "",
});

const normalizeAlertsResponse = (data) => {
  if (!Array.isArray(data?.alerts)) return [];

  return data.alerts
    .map(normalizeAlert)
    .filter((alert) => alert.id && alert.key);
};

export default class AgendaAlertModel {
  findAlerts = async () => {
    try {
      const { data } = await apiSimple.get(getAgendaAlertsUrl());
      return normalizeAlertsResponse(data);
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  dismissAlert = async (alert) => {
    try {
      await apiSimple.post(getAgendaAlertsUrl(`/${alert.id}/dismiss`), {
        key: alert.key,
      });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };
}
